// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import './custom_bootstrap'
import "./common/cookie/cookieconsent.min.js";
import "./controllers"

document.addEventListener("DOMContentLoaded", () => {
    const keyvisual = document.getElementById("keyvisual");

    if(keyvisual){
        const keyvisualTitle = document.getElementById("keyvisualTitle");
        const keyvisualBg = document.getElementById("keyvisualBg");
        keyvisualTitle.classList.add("show");
        keyvisualBg.classList.add("show");
    }

    const menuBtn = document.getElementById("menuBtn");
    const mainmenu = document.getElementById("mainmenu");

    if (menuBtn && mainmenu) {
        mainmenu.addEventListener("keydown", (e) => {
            if (e.key === "Escape") {
                menuBtn.click();
                menuBtn.focus();
            }
        });

        menuBtn.addEventListener("keydown", (e) => {
            if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                menuBtn.click();
            }
        });
    }

    document.querySelectorAll(".hassub").forEach(hassub => {
        const link = hassub.querySelector(".mainmenu-link");
        const submenu = hassub.querySelector(".submenu");
        const submenuLinks = submenu ? Array.from(submenu.querySelectorAll(".submenu-link")) : [];

        link.setAttribute("aria-haspopup", "true");
        link.setAttribute("aria-expanded", "false");

        const openSubmenu = () => {
            submenu.classList.add("open");
            hassub.classList.add("open");
            link.setAttribute("aria-expanded", "true");
        };

        const closeSubmenu = () => {
            submenu.classList.remove("open");
            hassub.classList.remove("open");
            link.setAttribute("aria-expanded", "false");
        };

        link.addEventListener("click", (e) => {
            if (submenu) {
                submenu.classList.toggle("open");
                hassub.classList.toggle("open");
                const isOpen = hassub.classList.contains("open");
                link.setAttribute("aria-expanded", isOpen ? "true" : "false");
            }
            e.preventDefault();
        });

        link.addEventListener("keydown", (e) => {
            if (!submenu) return;
            const isOpen = hassub.classList.contains("open");

            if (e.key === "ArrowDown") {
                e.preventDefault();
                if (!isOpen) openSubmenu();
                if (submenuLinks.length > 0) submenuLinks[0].focus();
            } else if (e.key === "ArrowUp") {
                e.preventDefault();
                if (!isOpen) openSubmenu();
                if (submenuLinks.length > 0) submenuLinks[submenuLinks.length - 1].focus();
            } else if (e.key === "Escape") {
                closeSubmenu();
            }
        });

        submenuLinks.forEach((submenuLink, index) => {
            submenuLink.addEventListener("keydown", (e) => {
                if (e.key === "ArrowDown") {
                    e.preventDefault();
                    const next = submenuLinks[index + 1];
                    if (next) next.focus();
                } else if (e.key === "ArrowUp") {
                    e.preventDefault();
                    if (index === 0) {
                        link.focus();
                    } else {
                        submenuLinks[index - 1].focus();
                    }
                } else if (e.key === "Escape") {
                    closeSubmenu();
                    link.focus();
                }
            });
        });

        hassub.addEventListener("focusout", (e) => {
            if (submenu && !hassub.contains(e.relatedTarget)) {
                closeSubmenu();
            }
        });
    });
})